<template>
  <v-row class="mt-3">
    <v-col class="text-center" cols="3" md="3" v-for="item in items">
      <v-btn
          :to="item.page"
          large
          color="secondary"
          class="pa-5 rounded-lg"
          @click="routeClick(item.route_name)"
          depressed
          fab
      >
        <v-img :src="item.icon_src" width="40" height="40"></v-img>
      </v-btn>
      <br />
      <span class="secondary--text mt-3" style="font-size: small; font-weight: bold">{{item.title}}</span>
    </v-col>

  </v-row>
</template>
<script>

export default {
  name: "HomeLinkBtns",
  mixins: [],
  data() {
    return {};
  },
  computed: {
    items() {
      console.log(this.user.user_type)
      if (this.user.user_type == 'ma') {
        return [
          {
            title: "فروشگاه",
            route_name: "Shop",
            icon_src: "/img/icons/comm.svg",
            page: { name: 'Shop' }
          },
          {
            title: "ارز",
            route_name: "Currency",
            icon_src: "/img/icons/currency.svg",
            page: { name: 'Currency' }
          },
          {
            title: "انبار",
            route_name: "Store",
            icon_src: "/img/icons/warehouse.svg",
            page: { name: 'Store' }
          },
          {
            title: "تامین کننده",
            route_name: "Supplier",
            icon_src: "/img/icons/supplier.svg",
            page: { name: 'Supplier' }
          },
          {
            title: "کسب و کار",
            route_name: "Business",
            icon_src: "/img/icons/business.svg",
            page: { name: 'Business' }
          },
          {
            title: "برند محصول",
            route_name: "Brand",
            icon_src: "/img/icons/productbrand3.svg",
            page: { name: 'Brand' }
          },
          {
            title: "فایده محصول",
            route_name: "Avail",
            icon_src: "/img/icons/productbenefit2.svg",
            page: { name: 'Avail' }
          },
          {
            title: "همه محصولات",
            route_name: "ProductList",
            icon_src: "/img/icons/allproducts.svg",
            page: { name: 'ProductList' }
          },

        ];
      }
      if(this.user.user_type == 'buow'){
        return [
          {
            title: "فروشگاه",
            route_name: "Shop",
            icon_src: "/img/icons/comm.svg",
            page: { name: 'Shop' }
          },
        ];

      }

    },

  },
  mounted() {
  },
  methods: {
    routeClick(routeName) {
      if (this.$route.name == routeName) {
        this.EventBus.$emit("sameRouteClick");
      }
    },


  },
};
</script>
<style>

</style>
